import { AdminInput, AdminToggle, AdminSectionCard } from './AdminFormInput';
import type { TemplateConfig } from '@/mocks/template-config';

interface ClientBoxFormProps {
  config: TemplateConfig['clientBox'];
  onChange: (config: TemplateConfig['clientBox']) => void;
}

export default function ClientBoxForm({ config, onChange }: ClientBoxFormProps) {
  const update = <K extends keyof TemplateConfig['clientBox']>(key: K, value: TemplateConfig['clientBox'][K]) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <div className="space-y-5">
      <AdminSectionCard title="Caixa do Cliente" icon="ri-user-line">
        <AdminToggle
          label="Mostrar Caixa do Cliente"
          checked={config.show}
          onChange={(v) => update('show', v)}
        />
        <AdminInput
          label="Título da Caixa"
          value={config.title}
          onChange={(e) => update('title', e.target.value)}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminInput
            label="Nome do Cliente"
            value={config.clientName}
            onChange={(e) => update('clientName', e.target.value)}
          />
          <AdminInput
            label="Empresa"
            value={config.clientCompany}
            onChange={(e) => update('clientCompany', e.target.value)}
          />
          <AdminInput
            label="Número da Proposta"
            value={config.proposalNumber}
            onChange={(e) => update('proposalNumber', e.target.value)}
          />
          <AdminInput
            label="Data"
            value={config.date}
            onChange={(e) => update('date', e.target.value)}
          />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-2">
          <AdminToggle
            label="Mostrar Nome"
            checked={config.showClientName}
            onChange={(v) => update('showClientName', v)}
          />
          <AdminToggle
            label="Mostrar Empresa"
            checked={config.showCompany}
            onChange={(v) => update('showCompany', v)}
          />
          <AdminToggle
            label="Mostrar Número"
            checked={config.showProposalNumber}
            onChange={(v) => update('showProposalNumber', v)}
          />
          <AdminToggle
            label="Mostrar Data"
            checked={config.showDate}
            onChange={(v) => update('showDate', v)}
          />
        </div>
      </AdminSectionCard>
    </div>
  );
}